import ContactUs from "./ContactUs";

const ContactUsPage = () => {
  return (
      <div className="flow-page">

        
        <div className="section-container">  
            <div id="contact" className="section-container contact-section" >
        
        {/* THis section is copied from home page so could be refactored later */}
          <div id="contact-form-wrapper">
            <div className="contact-wrapper">
              <div className="left-panel">
                <div className="text-container">
                  <div className="text-item">Rooted in Success.</div>
                  <div className="text-item">Rooted in Success.</div>
                  <div className="text-item focused">Rooted in Success.</div>
                  <div className="text-item">Rooted in Success.</div>
                  <div className="text-item">Rooted in Success.</div>
                </div>
            </div>
            <div className="right-panel">
              <ContactUs />
            </div>
          </div>
        </div>
      </div>
        
      </div>
      </div>
    );
};

export default ContactUsPage;